import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { GRADIENT_BLACK_COLOR, INPUT_COLOR_BORDER } from "../../utils/colors";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import Button from "../Buttons/Button";

const InsightActionableContainer = ({
  insight,
  disabled = false,
  actionButtonText,
  showActionButton = false,
  onActionButtonClick = null,
  buttonProps = {},
}) => {
  const isOptimizationApplied = insight?.isApplied;
  const isOptimizationDiscarded = insight?.isDiscarded;

  return (
    <Box
      sx={{
        mt: 0.5,
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        gap: 2,
        height: "100%",
      }}
    >
      <Box>
        <Typography
          variant="body2"
          sx={{
            color: "inherit",
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "anywhere",
            "& p": { margin: 0 },
            "& p + p": { marginTop: 1 },
          }}
          dangerouslySetInnerHTML={{
            __html: insight.action,
          }}
        />
      </Box>
      {insight?.forecast && !insight?.isRisky && (
        <Box
          sx={{
            py: 1,
            px: 1,
            borderRadius: 2,
            border: `1px solid ${INPUT_COLOR_BORDER}`,
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: 1,
              p: 1,
            }}
          >
            <Box>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  background: GRADIENT_BLACK_COLOR,
                  filter: "brightness(1.3)",
                  width: "fit-content",
                  maxWidth: "100%",
                  backgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  overflowWrap: "anywhere",
                }}
              >
                {insight.forecast.value}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  overflowWrap: "anywhere",
                }}
              >
                {insight.forecast.description}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {insight.forecast.description.includes("increase") ||
              insight.forecast?.type?.includes("increase") ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(0, 0, 0, 0.05)",
                    border: "1px solid rgba(0, 0, 0, 0.05)",
                    borderRadius: "50%",
                    p: 1,
                  }}
                >
                  <TrendingUpIcon sx={{ color: "white", fontSize: 30 }} />
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(0, 0, 0, 0.05)",
                    border: "1px solid rgba(0, 0, 0, 0.05)",
                    borderRadius: "50%",
                    p: 1,
                  }}
                >
                  <TrendingDownIcon sx={{ color: "white", fontSize: 30 }} />
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1,
          alignItems: "center",
        }}
      >
        {showActionButton && (
          <Button
            onClick={disabled ? null : onActionButtonClick}
            color={isOptimizationApplied ? "secondary" : "primary"}
            disabled={disabled || isOptimizationDiscarded}
            sx={{
              flex: "auto",
            }}
            {...buttonProps}
          >
            {actionButtonText}{" "}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default InsightActionableContainer;
